<template>
  <v-dialog
    persistent
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
    width="850"
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                label="Reason Number"
                v-model="selectedLuReason.ReasonNumber"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <LuApplicationStatus
                label="Status"
                v-model="selectedLuReason.StatusId"
                :rules="[(v) => !!v || 'required']"
              ></LuApplicationStatus>
            </v-col>
            <v-col cols="12" md="5">
              <LuValidation
                clearable
                label="Validation"
                v-model="selectedLuReason.ValidationId"
              ></LuValidation>
            </v-col>
            <v-col cols="12">
              <v-textarea
                auto-grow
                rows="1"
                label="Description"
                v-model="selectedLuReason.Description"
                :rules="[(v) => !!v || 'required']"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Next Reason Days"
                v-model="selectedLuReason.NextReasonDays"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="10">
              <LuReasonField
                label="Next Reason"
                v-model="selectedLuReason.NextReasonId"
              ></LuReasonField>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuReason.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="saveLuReasonDetails" :disabled="saving" color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuReason from '@classes/LuReason'
//templateTODO: import lookup components you plan to use
import LuValidation from '@components/select/luValidation/luValidation-single'
import LuReasonField from '@components/select/LuReason/LuReason-single'
import LuApplicationStatus from '@components/select/LuApplicationStatus/LuApplicationStatus-single'
export default {
  components: {
    //templateTodo: define lookup components you are using
    LuReasonField,
    LuApplicationStatus,
    LuValidation,
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuReason: new LuReason(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luReason', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luReason', ['saveLuReason']),
    async validate() {
      await this.$refs.form.validate()
    },
    editLuReason(entry) {
      this.selectedLuReason = new LuReason(entry)
      this.modalText = 'Edit Reason'
      this.dialog = !this.dialog
    },
    addLuReason() {
      this.modalText = 'Insert Reason'
      this.selectedLuReason = new LuReason()
      this.dialog = !this.dialog
    },
    async saveLuReasonDetails() {
      await this.validate()
      if (this.valid) {
        //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
        try {
          await this.saveLuReason(this.selectedLuReason.removeRelated())
          this.$emit('refresh')
          this.$emit('itemAdded', res.data)
          this.selectedLuReason = new LuReason()
          this.$refs.form.resetValidation()
        } catch (err) {}
        this.dialog = false
      }
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuReason = new LuReason()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
